import React from "react";
import { IHistory } from "../../../store/credit/types";
import { formatCurrency } from "../../../util/credit";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";

interface IProps {
    groupData?: IHistory[] | undefined;
}

const CreditHistoryTable: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    return (
        <React.Fragment>
            {props.groupData != null ? (
                <div className="table-container scroll">
                    <table className="m-table-generic">
                        <caption className="sr-only">JPMCB Card Summary</caption>
                        <thead>
                            <tr>
                                <th scope="col">
                                    <span className="sr-only">Item</span>
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <th key={"header" + history.accountNumber + index} scope="col">
                                        {history.bureau}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.accountNumber")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"an" + history.accountNumber + index}>
                                        {history.accountNumber}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                     {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.creditorName")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"cn" + history.accountNumber + index}>
                                        {history.creditorName}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.dateOpened")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"pd" + history.accountNumber + index}>
                                        {history.dateOpened && getFormattedDate(i18nService.get("Country"), history.dateOpened)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.dateClosed")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"dc" + history.accountNumber + index}>
                                        {history.dateClosed && getFormattedDate(i18nService.get("Country"), history.dateClosed)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.creditLimit")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"hb" + history.accountNumber + index}>
                                        {formatCurrency(history.highBalance)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.monthlyPayment")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"mp" + history.accountNumber + index}>
                                        {formatCurrency(history.monthlyPayment)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.accountBalance")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"ab" + history.accountNumber + index}>
                                        {formatCurrency(history.currentBalance)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.lastReported")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"lr" + history.accountNumber + index}>
                                        {history.dateReported && getFormattedDate(i18nService.get("Country"), history.dateReported)}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.accountStatus")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"as" + history.accountNumber + index}>
                                        {history.accountStatus}
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th scope="row" className="table-label">
                                    {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.bankAccountInfoSection.accountPastDue")}
                                </th>
                                {props.groupData.map((history: IHistory, index) => (
                                    <td key={"pd" + history.accountNumber + index}>
                                        {formatCurrency(history.amountPastDue)}
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default CreditHistoryTable;
